export default __webpack_public_path__ + "static/media/Country=ic-jp.79290ec3.svg";